import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as StoreProvider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import Auth0Provider from '@providers/auth0ProviderWithHistory';
import ResourceProvider from '@providers/resourceProvider';
import { AxiosProvider } from '@providers/axiosProvider';

import { FeatureFlagProvider } from '@modules/feature-flags/client/providers/FeatureFlagProvider';

import store from './ducks';
import App from './app';

import 'react-calendar/dist/Calendar.css';

import reportWebVitals from './reportWebVitals';

// New Relic Browser Agent の初期化
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { AgentOptions } from '@newrelic/browser-agent/loaders/agent';

// New Relic 設定
const options = {
  init: {
    accountID: process.env.REACT_APP_NEW_RELIC_ACCOUNT_ID,
    trustKey: process.env.REACT_APP_NEW_RELIC_TRUST_KEY,
    agentID: process.env.REACT_APP_NEW_RELIC_AGENT_ID,
  },
  info: {
    applicationName: process.env.REACT_APP_NEW_RELIC_APP_NAME,
    applicationID: process.env.REACT_APP_NEW_RELIC_APPLICATION_ID,
    licenseKey: process.env.REACT_APP_NEW_RELIC_LICENSE_KEY,
  },
  loader_config: {
    // 必要に応じてローダーの設定を追加
  },
} as AgentOptions;

if (process.env.REACT_APP_NEW_RELIC_ENABLE === '1') {
  new BrowserAgent(options);
}

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
  console.debug = () => {};
}

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <Auth0Provider>
            <AxiosProvider>
              <FeatureFlagProvider>
                <ResourceProvider lang="ja">
                  <App />
                </ResourceProvider>
              </FeatureFlagProvider>
            </AxiosProvider>
          </Auth0Provider>
        </BrowserRouter>
      </HelmetProvider>
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById('app'),
);

reportWebVitals();
